import {
    FETCH_STREAMING_PLATFORM_DATA_REQUEST,
    FETCH_STREAMING_PLATFORM_DATA_SUCCESS,
    FETCH_STREAMING_PLATFORM_DATA_FAILURE
} from "./streamingPlatformTypes";
const initialState = {
    loading: false,
    streamingPlatform: "",
    error: '',
  }
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case   FETCH_STREAMING_PLATFORM_DATA_REQUEST:
        return {
          ...state,
          loading: true
        }
      case FETCH_STREAMING_PLATFORM_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          streamingPlatform: action.payload,
          error: ''
        }
      case FETCH_STREAMING_PLATFORM_DATA_FAILURE:
        return {
          ...state,
          loading: false,
          streamingPlatform: [],
          error: action.payload
        }
       
      default: return state
    }
  }
  
  export default reducer